// extracted by mini-css-extract-plugin
export default {"ecospendBankBlock":"GGsUWzvySptTrsjWxuE8","bankField":"iC1g5iekN0g7eYpfciNA"};